import script from "./EditUploadsMetadataModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditUploadsMetadataModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditUploadsMetadataModal.vue?vue&type=style&index=0&id=17032ebc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17032ebc"]])

export default __exports__